import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router";
import { Button, Sidebar } from "../ui";
import { Menu } from "lucide-react";

function LandingHeader() {
    const location = useLocation();
    const [activePath, setActivePath] = useState("");
    const [visibleSidebar, setVisibleSidebar] = useState(false);

    useEffect(() => {
        setActivePath(location.pathname);
    }, [location]);

    const navItems = [
        { label: "Eventos", path: "/" },
        { label: "Loja Oficial", path: "/loja" },
        { label: "Para atletas", path: "/para-atletas" },
        { label: "Para Organizadores", path: "/para-organizadores" },
        { label: "Como Funciona", path: "/como-funciona" },
        { label: "Contato", path: "/contato" },
    ];

    const logo = (
        <img
            src={require('../../statics/img/VERDE-2.png')}
            alt="logo"
            className="h-7 md:h-8 w-auto object-contain mr-2 transition-all"
        />
    );

    return (
        <header className="landing-header py-3 px-4 md:px-6 flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="no-underline flex items-center gap-2">
                <div>{logo}</div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-4">
                {navItems.map((item, idx) => (
                    <Link
                        key={idx}
                        to={item.path}
                        className={`landing-nav-link capitalize-first ${activePath === item.path ? "active" : ""}`}
                        style={{ fontSize: "0.9rem", color: "#CBD5E1" }}
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>

            {/* Actions (Desktop) */}
            <div className="hidden lg:flex items-center gap-4">
                <Link
                    to="/login?cadastro=true"
                    onClick={() => {
                        if (window.location.pathname === "/login") {
                            window.dispatchEvent(new CustomEvent("open-register-modal"));
                        }
                    }}
                    className="no-underline"
                >
                    <Button 
                        label="CADASTRE-SE" 
                        variant="outline"
                        size="sm"
                        className="border-urb-primary text-urb-primary hover:bg-urb-primary/10 rounded-lg px-4 py-2 font-bold tracking-wider"
                    />
                </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
                type="button"
                className="lg:hidden p-2 text-white hover:text-urb-primary transition-colors cursor-pointer bg-transparent border-none"
                onClick={() => setVisibleSidebar(true)}
                aria-label="Abrir menu"
            >
                <Menu className="w-6 h-6" />
            </button>

            {/* Mobile Navigation Sidebar */}
            <Sidebar
                visible={visibleSidebar}
                position="right"
                onHide={() => setVisibleSidebar(false)}
                className="bg-urb-dark border-l border-urb-border"
            >
                <div className="flex flex-col gap-4 mt-2">
                    <div className="logo-urb self-start">URB</div>
                    <div className="flex flex-col gap-3 mt-4">
                        {navItems.map((item, idx) => (
                            <Link
                                key={idx}
                                to={item.path}
                                className={`landing-nav-link text-xl py-2 ${activePath === item.path ? "active" : ""}`}
                                onClick={() => setVisibleSidebar(false)}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </div>
                    <hr className="my-3 w-full border-t border-urb-border" />
                    <div className="flex flex-col gap-3">
                        <Link
                            to="/login"
                            className="no-underline text-white font-medium py-2.5 text-center rounded-lg hover:bg-white/10 transition-colors"
                            onClick={() => setVisibleSidebar(false)}
                        >
                            ENTRAR
                        </Link>
                        <Link
                            to="/login"
                            className="no-underline w-full"
                            onClick={() => setVisibleSidebar(false)}
                        >
                            <Button label="CRIAR EVENTO" variant="primary" className="w-full font-bold" />
                        </Link>
                    </div>
                </div>
            </Sidebar>
        </header>
    );
}

export default LandingHeader;
